import { ConfigClientEnum } from "@interfaces/enums/apiData.enum";

interface IClientConfig {
  documentTitle: string;
}

export const clientConfig: Record<ConfigClientEnum, IClientConfig> = {
  [ConfigClientEnum.cgg]: {
    documentTitle: "Chihuly Garden and Glass Free Photos",
  },
  [ConfigClientEnum.sn]: {
    documentTitle: "Spacebook",
  },
};
